module.exports = __webpack_public_path__ + "static/media/velour4A.5568ee2e.jpg";